import React, { useEffect } from "react";
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMenus } from "../../actions/menus";
import { getBanners } from "../../actions/banners";
import { getContents } from "../../actions/contents";
import { getContentByName, getSettingByKey } from "../../helpers/common";
import parse from "html-react-parser";
import { getSettings } from "../../actions/settings";
import { getClientTestimonials } from "../../actions/clientTestimonials";
import { getCategory } from "../../actions/categories";
import { getFaqs } from "../../actions/faqs";
import {
  getEmployerCompanies,
  getEmployerJobs,
  getJobsApplications,
  getPlanDetails,
} from "../../actions/employer";
import { getJobs } from "../../actions/jobs";
import { getBookmarkJobs } from "../../actions/bookmarkJob";
import {
  getCandidateCertifications,
  getCandidateExperiences,
  getCandidateQualifications,
} from "../../actions/customer";
import { getBookmarkCandidates } from "../../actions/bookmarkCandidates";
import { getJobLocations } from "../../actions/jobLocations";
import { getNotifications } from "../../actions/notifications";
import { getCandiJobsApplications } from "../../actions/candidate";
import StickyWhatsApp from "../../helpers/Common/StickyWhatsApp";
import { getPlans } from "../../actions/orders";
import { useNavigate } from "react-router-dom";
import GooglePlayDownload from "../../assets/images/google-play-download.png";
import InstagramIcon from "../../assets/images/social-media-icons/instagram.png";
import FacebookIcon from "../../assets/images/social-media-icons/facebook.png";
import LinkedinIcon from "../../assets/images/social-media-icons/linkedin.png";
import StickyShare from "../../helpers/Common/stickyshare";

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customer = useSelector((state) => state.customer.profile);
  console.log("Customer*", customer);

  useEffect(() => {
    dispatch(getMenus());
    dispatch(getSettings());
    dispatch(getJobLocations());
    dispatch(getCategory());
    dispatch(getFaqs());
    dispatch(getJobs("&JobsSearch[is_active]=1"));
    dispatch(getBanners("featured_companies"));
    dispatch(getBanners("homepage_banners"));
    dispatch(getBanners("trusted_by_companies"));
    dispatch(getBanners("assets"));
    dispatch(getContents("partial_contents"));
    dispatch(getContents("job_locations"));
    dispatch(getContents("job_categories"));
    dispatch(getContents("aboutus_key_features"));
    dispatch(getContents("services"));
    dispatch(getContents("team"));
    dispatch(getPlans());
    dispatch(getClientTestimonials());
  }, [dispatch]);

  // only for logged in user
  useEffect(() => {
    if (customer?.id) {
      console.log("🔔 [FOOTER] User logged in. ID:", customer.id, "| Setting up notification listener.");
      // This dispatch is used for immediate notification retrieval after login.
      dispatch(getNotifications(navigate));

      // Set up an interval to fetch notifications every 8 seconds
      const intervalId = setInterval(() => {
        dispatch(getNotifications(navigate));
      }, 10000);

      // Return a cleanup function to clear the interval when the component unmounts
      // or if the customer.id changes (for example, the customer logs out).
      return () => clearInterval(intervalId);
    }
  }, [customer?.id, dispatch, navigate]);

  // Employer
  // ==========================================
  // FIXED: Employer Sync Block
  // ==========================================
  useEffect(() => {
    // 1. रूट ऑब्जेक्ट से सेफली वैल्यूज निकालें
    const id = customer?.id;
    const currentType = customer?.customerType ?? customer?.customer_type;

    console.group("💼 [FOOTER] EMPLOYER SYNC EVALUATION");
    console.log("Detected Profile Object:", customer);
    console.log("Extracted ID:", id);
    console.log("Extracted Customer Type:", currentType);

    // अगर ID या Type मौजूद नहीं है, तो आगे न बढ़ें
    if (id === undefined || currentType === undefined) {
      console.log("⚠️ Evaluation stopped: Missing ID or customerType");
      console.groupEnd();
      return;
    }

    // 2. EMPLOYER LOGIC (Type: 1)
    if (Number(currentType) === 1) {
      console.log("✅ SUCCESS: Role is EMPLOYER (Type: 1). Dispatching Employer data for ID:", id);

      dispatch(getEmployerJobs(id));
      dispatch(getEmployerCompanies(id));
      dispatch(getJobsApplications(id));
      dispatch(getBookmarkCandidates(id));
      dispatch(getPlanDetails()); // अगर यह स्पेसिफिकली एम्प्लॉयर प्लान्स के लिए है
    }

    // 3. EMPLOYEE / CANDIDATE LOGIC (Type: 0)
    else if (Number(currentType) === 0) {
      console.log("🧑‍💻 Role is CANDIDATE (Type: 0) inside Employer sync block.");
    }
    console.groupEnd();

  }, [customer, dispatch]); // पूरे ऑब्जेक्ट को ट्रैक करना या लोकल वेरिएबल्स के बिना इसे क्लीन रखना बेहतर है

  // ==========================================
  // FIXED: Candidate Sync Block (Your Bookmarks!)
  // ==========================================
  useEffect(() => {
    const id = customer?.id;
    const currentType = customer?.customerType ?? customer?.customer_type;

    console.group("🧑‍💻 [FOOTER] CANDIDATE SYNC EVALUATION");
    console.log("Detected Type:", currentType, " | Detected ID:", id);

    if (Number(currentType) === 0 && id) {
      console.log("✅ SUCCESS: Type is Candidate (0). Fetching candidate data and bookmarks now!");
      dispatch(getCandiJobsApplications(id));
      dispatch(getBookmarkJobs(id));
      dispatch(getCandidateQualifications(id));
      dispatch(getCandidateCertifications(id));
      dispatch(getCandidateExperiences(id));
    } else {
      console.log("ℹ️ REJECTED: User is not Candidate (0) or missing ID.");
    }
    console.groupEnd();
  }, [customer?.customerType, customer?.customer_type, customer?.id, dispatch]);

  const menus = useSelector((state) => state.menus.data);
  const rawContent = useSelector((state) => state.contents["partial_contents"]);

  // Ye check karega: Agar rawContent array hai toh wahi use karo, 
  // warna uske andar se .data nikal lo, aur agar kuch bhi nahi hai toh khali array [] rakho.
  const content = Array.isArray(rawContent) ? rawContent : (rawContent?.data || []);
  const footerDescription = getContentByName(
    content,
    "footer_description"
  )?.content;

  // Menus
  // 1. Pehle menus ko safe karein (agar data object mein hai toh use nikal lein)
  const safeMenus = Array.isArray(menus) ? menus : (menus?.data || []);

  // 2. Ab safeMenus par filter chalayein (Ab error nahi aayega)
  const footerCompany = safeMenus.filter((menu) => menu.category === "footer_company");

  const footerForJob = safeMenus.filter((menu) => menu.category === "footer_for_job");

  const footerForCandidates = safeMenus.filter((menu) => menu.category === "footer_candidates");

  const footerSupport = safeMenus.filter((menu) => menu.category === "footer_support");
  const footerContactUs = safeMenus.filter((menu) => menu.category === "footer_contactus");
  const footerEbook = safeMenus.filter((menu) => menu.category === "footer_ebook");
  const settings = useSelector((state) => state.settings.data);

  // Social Icons
  const facebookLink = getSettingByKey(
    settings,
    "social_links_facebook"
  )?.value;
  const instaLink = getSettingByKey(settings, "social_links_instagram")?.value;
  const googlePlayStoreLink = getSettingByKey(
    settings,
    "social_links_play_store"
  )?.value;
  const linkedinLink = getSettingByKey(
    settings,
    "social_links_linekdin"
  )?.value;

  // Copyright Text
  const copyrightText = getSettingByKey(settings, "copyright_text")?.value;

  const scrollTop = () => {
    return window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <React.Fragment>
      <footer className="bg-primary text-white py-5">
        <Container>
          <Row className="gy-5">
            {/* Brand Section - Centered on Mobile, Left on Desktop */}
            <Col lg={4} xs={12} className="text-center text-lg-start">
              <div className="pe-lg-5">
                <h3 className="text-white fw-bold mb-3">Webvi<span className="text-white-50">.</span></h3>
                <div className="text-white-50 lh-base mb-4" style={{ fontSize: '0.92rem' }}>
                  {parse(footerDescription ?? "")}
                </div>

                <div className="social-links-container">
                  <p className="text-white fw-semibold small text-uppercase mb-3" style={{ letterSpacing: '1px' }}>Follow Our Journey</p>
                  <div className="d-flex gap-3 justify-content-center justify-content-lg-start">
                    {facebookLink && (
                      <a href={facebookLink} target="_blank" rel="noreferrer" className="social-link-item">
                        <img src={FacebookIcon} alt="Facebook" className="social-icon-img" />
                      </a>
                    )}
                    {linkedinLink && (
                      <a href={linkedinLink} target="_blank" rel="noreferrer" className="social-link-item">
                        <img src={LinkedinIcon} alt="Linkedin" className="social-icon-img" />
                      </a>
                    )}
                    {instaLink && (
                      <a href={instaLink} target="_blank" rel="noreferrer" className="social-link-item">
                        <img src={InstagramIcon} alt="Instagram" className="social-icon-img" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            {/* Links Section - Two columns on mobile side-by-side */}
            <Col lg={4} md={8} xs={12}>
              <Row>
                <Col xs={6} className="text-start">
                  <h6 className="text-white text-uppercase fw-bold mb-4 small" style={{ letterSpacing: '1.5px' }}>Company</h6>
                  <ul className="list-unstyled footer-list mb-0">
                    {footerCompany.map((menu, key) => (
                      <li key={"company-" + key} className="mb-2">
                        <Link to={menu.url} onClick={scrollTop} className="text-white-50 text-decoration-none transition-link small">
                          <i className="mdi mdi-chevron-right me-1"></i>{menu.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Col>
                <Col xs={6} className="text-start">
                  <h6 className="text-white text-uppercase fw-bold mb-4 small" style={{ letterSpacing: '1.5px' }}>Support</h6>
                  <ul className="list-unstyled footer-list mb-0">
                    {footerSupport.map((menu, key) => (
                      <li key={"support-" + key} className="mb-2">
                        <Link to={menu.url} onClick={scrollTop} className="text-white-50 text-decoration-none transition-link small">
                          <i className="mdi mdi-chevron-right me-1"></i>{menu.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Col>

            {/* Contact & App Section - Stacks on Mobile */}
            <Col lg={4} xs={12} className="text-center text-lg-start">
              <h6 className="text-white text-uppercase fw-bold mb-4 small" style={{ letterSpacing: '1.5px' }}>Contact Us</h6>
              <ul className="list-unstyled footer-list mb-4">
                {footerContactUs.map((menu, key) => (
                  <li key={"contact-" + key} className="mb-2">
                    <Link to={menu.url} onClick={scrollTop} className="text-white-50 text-decoration-none transition-link small">
                      {menu.name}
                    </Link>
                  </li>
                ))}
              </ul>

              {googlePlayStoreLink && (
                <div className="d-inline-block p-2 rounded-3" style={{ background: 'rgba(255,255,255,0.1)' }}>
                  <a href={googlePlayStoreLink} target="_blank" rel="noreferrer">
                    <img src={GooglePlayDownload} alt="Google Play" style={{ maxWidth: '130px' }} />
                  </a>
                </div>
              )}
            </Col>
          </Row>
        </Container>

        {/* Copyright Bar */}
        <div className="mt-5 py-4 border-top border-white border-opacity-10">
          <Container>
            <Row className="align-items-center">
              <Col md={12} className="text-center">
                <p className="text-white-50 small mb-1">
                  {parse(copyrightText ?? "")}
                </p>
                <p className="text-white small fw-bold mb-0">
                  Copyright © 2026 Webvi. All rights reserved.
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <StickyWhatsApp />
        <StickyShare />

      </footer>
    </React.Fragment>
  );
};

export default Footer;